<template>
  <div class="px-2">
    <div class="d-flex align-center pt-2 pb-1">
      <span class="ml-1 font-19 font-weight-medium">Análise Slow-no moving</span>

      <div class="ml-3 cursor-pointer" @click="tipo_visao = (tipo_visao === 'F') ? 'Q' : 'F'">
        <v-icon size="20">mdi-swap-horizontal</v-icon>
        <span class="font-12 ml-1">{{ (tipo_visao === 'F') ? 'Visão financeira' : 'Visão quantitativa' }}</span>
      </div>

      <v-divider vertical class="mx-3" />

      <v-spacer />

      <FiltrosUniversalAvancado />

      <EvolucaoEstoqueParado />

      <MovimentacaoEstoque />

      <ExportacaoParaExcel />
    </div>

    <Tabela
      :tipo_visao="tipo_visao"
      @duplo-click:linha="linha => linha_duplamente_clicada = linha"
    />

    <LinhaDuplamenteClicada :linha="linha_duplamente_clicada" />
  </div>
</template>

<script>
import Tabela from '@/components/Diagnostico/SlowNoMoving/Tabela.vue';
import LinhaDuplamenteClicada from "@/components/Diagnostico/LinhaDuplamenteClicada/Index";
import ExportacaoParaExcel from "@/components/Diagnostico/ExportacaoParaExcel";
import EvolucaoEstoqueParado from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/Index.vue";
import MovimentacaoEstoque from "@/components/Diagnostico/SlowNoMoving/MovimentacaoEstoque/Index";
import FiltrosUniversalAvancado from "@/components/utils/FiltrosUniversalAvancado.vue";

export default {
  name: "SlowNoMoving",
  components: {
    FiltrosUniversalAvancado,
    ExportacaoParaExcel,
    LinhaDuplamenteClicada,
    Tabela,
    EvolucaoEstoqueParado,
    MovimentacaoEstoque,
  },
  data: () => ({
    tipo_visao: localStorage.diagnostico_tipo_visao || 'F',
    linha_duplamente_clicada: null
  })
}
</script>

<style scoped>

</style>
